import React, { useEffect, useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Sidebar } from "../Sidebar";
import { Header } from "../Header";
import Banner from "../components/Banner";
import SliderContainer from "../components/SliderContainer";
import { Footer } from "../Footer";


const EvolutionGames = () => {
  const [isSidebar, setSidebar] = useState(false);
  const PopularGames = [
    {
      src: "/Evolution_games/2-Hand-Casino-Hold_em_thumbnail-400x225.jpg",
      name: "2-Hand Casino Hold'em",
      tableCode: "EVO_hcHold'em",
      provider: "vking",
      tpGameId:604,
      endpoint:'evolution-games'
    },
    {
      src: "/Evolution_games/fp_blackjack.jpg",
      name: "First Person Blackjack",
      tableCode: "EVO_fpBlackjack",
      provider: "vking",
      tpGameId:604,
      endpoint:'evolution-games'
    },
    {
      src: "/Evolution_games/dragon_tiger_fp.jpg",
      name: "First Person Dragon Tiger",
      tableCode: "Evo_FPDTiger",
      provider: "vking",
      tpGameId:604,
      endpoint:'evolution-games'
    },
    {
      src: "/Evolution_games/fp_dream_catcher.jpg",
      name: "First Person Dream Catcher",
      tableCode: "EVO_Fpdcatcher",
      provider: "vking",
      tpGameId:604,
      endpoint:'evolution-games'
    },
    {
      src: "/Evolution_games/fp_roulette.jpg",
      name: "First Person Roulette",
      tableCode: "EVO_fpRoulette",
      provider: "vking",
      tpGameId:604,
      endpoint:'evolution-games'
    },
    {
      src: "/Evolution_games/fp_baccarat.jpg",
      name: "First Person baccarat",
      tableCode: "EVO_Fpbaccarat",
      provider: "vking",
      tpGameId:604,
      endpoint:'evolution-games'
    },
    {
      src: "/Evolution_games/Power-Blackjack_thumbnail-400x225.jpg",
      name: "Power Blackjack",
      tableCode: "EVO_pbljk",
      provider: "vking",
      tpGameId:604,
      endpoint:'evolution-games'
    },
    {
      src: "/Evolution_games/speed_roulette_thumbnail_1000x563-400x225.jpg",
      name: "Speed Roulette",
      tableCode: "EVO_SRoulette",
      provider: "vking",
      tpGameId:604,
      endpoint:'evolution-games'
    },
    {
      src: "/Evolution_games/double_ball_roulette.jpg",
      name: "Double Ball Roulette",
      tableCode: "EVO_dbRoulette",
      provider: "vking",
      tpGameId:604,
      endpoint:'evolution-games'
    },
    {
      src: "/Evolution_games/american_roulette_thumbnail_1000x563-400x225.jpg",
      name: "American Roulette",
      tableCode: "EVO_arlt",
      provider: "vking",
      tpGameId:604,
      endpoint:'evolution-games'
    },
    {
      src: "/Evolution_games/mega_ball_web_imagery_1000x563_2023_01-400x225.jpg",
      name: "Mega Ball",
      tableCode: "EVO_mbl",
      provider: "vking",
      tpGameId:604,
      endpoint:'evolution-games'
    },
    {
      src: "/Evolution_games/baccarat_1000-400x225.png",
      name: "Baccarat",
      tableCode: "EVO_bcrt",
      provider: "vking",
      tpGameId:604,
      endpoint:'evolution-games'
    },
    {
      src: "/Evolution_games/double_ball_roulette_thumbnail_1000x563_2023_08-400x225.jpg",
      name: "Double Ball Roulette",
      tableCode: "EVO_dbRoulette",
      provider: "vking",
      tpGameId:604,
      endpoint:'evolution-games'
    },
    
    {
      src: "/Evolution_games/first_person_craps_thumbnail_1000x563_2023_03-400x225.jpg",
      name: "First Person Craps",
      tableCode: "EVO_FPCraps",
      provider: "vking",
      tpGameId:604,
      endpoint:'evolution-games'
    },
    {
      src: "/Evolution_games/football_studio_dice_thumbnail_1000x563_2023_04-400x225.jpg",
      name: "Football Studio Dice",
      tableCode: "EVO_Fpfstudio",
      provider: "vking",
      tpGameId:604,
      endpoint:'evolution-games'
    },
    {
      src: "/Evolution_games/fp_mega_ball_thumbnail_1000x563_2023_04-400x225.jpg",
      name: "FP Mega Ball",
      tableCode: "EVO_fpmBall",
      provider: "vking",
      tpGameId:604,
      endpoint:'evolution-games'
    },
    {
      src: "/Evolution_games/instant_roulette_thumbnail_1000x563-400x225.jpg",
      name: "Instant Roulette",
      tableCode: "EVO_inrt",
      provider: "vking",
      tpGameId:604,
      endpoint:'evolution-games'
    },
    {
      src: "/Evolution_games/lightning_roulette_web_imagery_1000x563_2023_01-400x225.jpg",
      name: "Lightning Roulette",
      tableCode: "EVO_LRoulette",
      provider: "vking",
      tpGameId:604,
      endpoint:'evolution-games'
    },
    // {
    //   src: "/Evolution_games/1000x563_xxxtreme-lighning-bacc-fp-400x225.png",
    //   name: "XXXtreme Lightning",
    //   tableCode: "EVO_XLigRou",
    //   provider: "vking",
    //   tpGameId:604
    // },
    // {
    //   src: "/Evolution_games/32_cards_1000-400x225.png",
    //   name: "32 Cards",
    //   tableCode: "EVO_XLigRou",
    //   provider: "vking",
    //   tpGameId:604
    // },
    
    // {
    //   src: "/Evolution_games/always_8_baccarat_web_imagery_1000x563_2024_12-400x225.jpg",
    //   name: "Always 8 baccarat",
    //   tableCode: "EVO_XLigRou",
    //   provider: "vking",
    //   tpGameId:604
    // },
    
    // {
    //   src: "/Evolution_games/andar_bahar_1000-400x225.png",
    //   name: "Andar Bahar",
    //   tableCode: "EVO_XLigRou",
    //   provider: "vking",
    //   tpGameId:604
    // },
    // {
    //   src: "/Evolution_games/auto_roulette_thumbnail_1000x563-400x225.jpg",
    //   name: "Auto Roulette",
    //   tableCode: "EVO_XLigRou",
    //   provider: "vking",
    //   tpGameId:604
    // },
    // {
    //   src: "/Evolution_games/bac_bo_web_imagery_1000x563_2023_01-400x225.jpg",
    //   name: "Bac Bo",
    //   tableCode: "EVO_XLigRou",
    //   provider: "vking",
    //   tpGameId:604
    // },
    
    // {
    //   src: "/Evolution_games/balloon_race_thumbnail_1000x563_2024_06-400x225.jpg",
    //   name: "Balloon Race",
    //   tableCode: "EVO_XLigRou",
    //   provider: "vking",
    //   tpGameId:604
    // },
    // {
    //   src: "/Evolution_games/bet_on_numbers_1000-400x225.png",
    //   name: "Bet on Numbers",
    //   tableCode: "EVO_XLigRou",
    //   provider: "vking",
    //   tpGameId:604
    // },
    // {
    //   src: "/Evolution_games/bet_on_teen_patti_1000-400x225.png",
    //   name: "Bet on Teen Patti",
    //   tableCode: "EVO_XLigRou",
    //   provider: "vking",
    //   tpGameId:604
    // },
    // {
    //   src: "/Evolution_games/big-baller-thumbnail-400x225.jpg",
    //   name: "Big Baller",
    //   tableCode: "EVO_XLigRou",
    //   provider: "vking",
    //   tpGameId:604
    // },
    // {
    //   src: "/Evolution_games/blackjack_1000-400x225.png",
    //   name: "Blackjack",
    //   tableCode: "EVO_XLigRou",
    //   provider: "vking",
    //   tpGameId:604
    // },
    // {
    //   src: "/Evolution_games/blackjack_party_thumbnail_1000x563-400x225.jpg",
    //   name: "Blackjack Party",
    //   tableCode: "EVO_XLigRou",
    //   provider: "vking",
    //   tpGameId:604
    // },
    // {
    //   src: "/Evolution_games/cash_or_crash_thumbnail_1000x563-400x225.jpg",
    //   name: "Cash or Crash",
    //   tableCode: "EVO_XLigRou",
    //   provider: "vking",
    //   tpGameId:604
    // },
    // {
    //   src: "/Evolution_games/casino_holdem_1000-400x225.png",
    //   name: "Casino Hold'em",
    //   tableCode: "EVO_XLigRou",
    //   provider: "vking",
    //   tpGameId:604
    // },
    // {
    //   src: "/Evolution_games/casino_holdem_thumbnail_1000x563-400x225.jpg",
    //   name: "Casino Hold'em Thumbnail",
    //   tableCode: "EVO_XLigRou",
    //   provider: "vking",
    //   tpGameId:604
    // },
    // {
    //   src: "/Evolution_games/craps_thumbnail_1000x563_2023_03-400x225.jpg",
    //   name: "Craps",
    //   tableCode: "EVO_XLigRou",
    //   provider: "vking",
    //   tpGameId:604
    // },
    // {
    //   src: "/Evolution_games/crazy_balls_thumbnail_1000x563_2024_10_01-1-400x225.jpg",
    //   name: "Crazy Balls",
    //   tableCode: "EVO_XLigRou",
    //   provider: "vking",
    //   tpGameId:604
    // },
    // {
    //   src: "/Evolution_games/crazy_coin_flip_web_imagery_1000x563_2023_01_02-400x225.jpg",
    //   name: "Crazy Coin Flip",
    //   tableCode: "EVO_XLigRou",
    //   provider: "vking",
    //   tpGameId:604
    // },
    // {
    //   src: "/Evolution_games/crazy_pachinko_thumbnail_1000x563_2023_11-400x225.jpg",
    //   name: "Crazy Pachinko",
    //   tableCode: "EVO_XLigRou",
    //   provider: "vking",
    //   tpGameId:604
    // },
    // {
    //   src: "/Evolution_games/crazy_time_thumbnail_1000x563_2023_03-400x225.jpg",
    //   name: "Crazy Time",
    //   tableCode: "EVO_XLigRou",
    //   provider: "vking",
    //   tpGameId:604
    // },
    // {
    //   src: "/Evolution_games/cricket_war_1000-400x225.png",
    //   name: "Cricket War",
    //   tableCode: "EVO_XLigRou",
    //   provider: "vking",
    //   tpGameId:604
    // },
    // {
    //   src: "/Evolution_games/deal_or_no_deal_web_imagery_1000x563_2024_09-400x225.jpg",
    //   name: "Deal or No Deal",
    //   tableCode: "EVO_XLigRou",
    //   provider: "vking",
    //   tpGameId:604
    // },
    
    // {
    //   src: "/Evolution_games/dragon_tiger_1000-400x225.png",
    //   name: "Dragon Tiger",
    //   tableCode: "EVO_XLigRou",
    //   provider: "vking",
    //   tpGameId:604
    // },
    // {
    //   src: "/Evolution_games/dragon_tiger_web_imagery_1000x563_2023_01_02-400x225.jpg",
    //   name: "Dragon Tiger Web Imagery",
    //   tableCode: "EVO_XLigRou",
    //   provider: "vking",
    //   tpGameId:604
    // },
   
    // {
    //   src: "/Evolution_games/easy_blackjack_thumbnail_1000x563_2024_11-400x225.jpg",
    //   name: "Easy Blackjack",
    //   tableCode: "EVO_XLigRou",
    //   provider: "vking",
    //   tpGameId:604
    // },
    // {
    //   src: "/Evolution_games/extra_chilli_epic_spins_thumbnail_1000x563_2023_05-400x225.jpg",
    //   name: "Extra Chilli Epic Spins",
    //   tableCode: "EVO_XLigRou",
    //   provider: "vking",
    //   tpGameId:604
    // },
    // {
    //   src: "/Evolution_games/ez_dealer_roulette_1000-400x225.png",
    //   name: "EZ Dealer Roulette",
    //   tableCode: "EVO_XLigRou",
    //   provider: "vking",
    //   tpGameId:604
    // },
    // {
    //   src: "/Evolution_games/fan_tan_web_imagery_1000x563_2023_01-400x225.jpg",
    //   name: "Fan Tan",
    //   tableCode: "EVO_XLigRou",
    //   provider: "vking",
    //   tpGameId:604
    // },
    // {
    //   src: "/Evolution_games/first_person_-prosperirty_tree_baccarat_thumb-400x225.png",
    //   name: "First Person Prosperity Tree Baccarat",
    //   tableCode: "EVO_XLigRou",
    //   provider: "vking",
    //   tpGameId:604
    // },
    
    // {
    //   src: "/Evolution_games/first_person_hilo_thumbnail_1000x563_2024_06-400x225.jpg",
    //   name: "First Person HiLo",
    //   tableCode: "EVO_XLigRou",
    //   provider: "vking",
    //   tpGameId:604
    // },
    
    // {
    //   src: "/Evolution_games/fp_deal_or_no_deal_thumbnail_400x225_2023_05.jpg",
    //   name: "FP Deal or No Deal",
    //   tableCode: "EVO_XLigRou",
    //   provider: "vking",
    //   tpGameId:604
    // },
    // {
    //   src: "/Evolution_games/fp_lightning_lotto_thumbnail_1000x563_2023_08-400x225.jpg",
    //   name: "FP Lightning Lotto",
    //   tableCode: "EVO_XLigRou",
    //   provider: "vking",
    //   tpGameId:604
    // },
    
    // {
    //   src: "/Evolution_games/funky_time_thumbnail_1000x563_2023_05-400x225.jpg",
    //   name: "Funky Time",
    //   tableCode: "EVO_XLigRou",
    //   provider: "vking",
    //   tpGameId:604
    // },
    // {
    //   src: "/Evolution_games/Free-Bet-Blackjack_thumbnail-400x225.jpg",
    //   name: "Free Bet Blackjack",
    //   tableCode: "EVO_XLigRou",
    //   provider: "vking",
    //   tpGameId:604
    // },
    // {
    //   src: "/Evolution_games/Gold-Bar-Roulette_thumbnail-400x225.jpg",
    //   name: "Gold Bar Roulette",
    //   tableCode: "EVO_XLigRou",
    //   provider: "vking",
    //   tpGameId:604
    // },
    // {
    //   src: "/Evolution_games/gold_vault_roulette_thumbnail_1000x563_2023_08-400x225.jpg",
    //   name: "Gold Vault Roulette",
    //   tableCode: "EVO_XLigRou",
    //   provider: "vking",
    //   tpGameId:604
    // },
    // {
    //   src: "/Evolution_games/golden_balls_1000-400x225.png",
    //   name: "Golden Balls",
    //   tableCode: "EVO_XLigRou",
    //   provider: "vking",
    //   tpGameId:604
    // },
    // {
    //   src: "/Evolution_games/golden_wealth_baccarat_web_imagery_1000x563_2023_01-400x225.jpg",
    //   name: "Golden Wealth Baccarat",
    //   tableCode: "EVO_XLigRou",
    //   provider: "vking",
    //   tpGameId:604
    // },
    // {
    //   src: "/Evolution_games/gonzo_treasure_map_thumbnail_1000x563_2023_08-1-1-400x225.jpg",
    //   name: "Gonzo's Treasure Map",
    //   provider: "vking",
    //   tpGameId:604
    // },
    // {
    //   src: "/Evolution_games/immersive_roulette_thumbnail_1000x563-400x225.jpg",
    //   name: "Immersive Roulette",
    //   tableCode: "EVO_XLigRou",
    //   provider: "vking",
    //   tpGameId:604
    // },
    // {
    //   src: "/Evolution_games/infinite_bet_stacker_blackjack_thumbnail_1000x563_2024_10_01-400x225.jpg",
    //   name: "Infinite Bet Stacker Blackjack",
    //   tableCode: "EVO_XLigRou",
    //   provider: "vking",
    //   tpGameId:604
    // },
    // {
    //   src: "/Evolution_games/infinite_blackjack_thumbnail_1000x563-400x225.jpg",
    //   name: "Infinite Blackjack",
    //   tableCode: "EVO_XLigRou",
    //   provider: "vking",
    //   tpGameId:604
    // },
    // {
    //   src: "/Evolution_games/infinite_fun_fun_21_blackjack_web_imagery_1000x563_2024_05-400x225.jpg",
    //   name: "Infinite Fun Fun 21 Blackjack",
    //   tableCode: "EVO_XLigRou",
    //   provider: "vking",
    //   tpGameId:604
    // },
    
    // {
    //   src: "/Evolution_games/instant_super_sic_bo_thumbnail_1000x563_2023_11-400x225.jpg",
    //   name: "Instant Super Sic Bo",
    //   tableCode: "EVO_XLigRou",
    //   provider: "vking",
    //   tpGameId:604
    // },
    // {
    //   src: "/Evolution_games/lightning_ball_thumbnail_1000x563_2024_08_01-400x225.jpg",
    //   name: "Lightning Ball",
    //   tableCode: "EVO_XLigRou",
    //   provider: "vking",
    //   tpGameId:604
    // },
    // {
    //   src: "/Evolution_games/lightning_blackjack_thumbnail-400x225.jpg",
    //   name: "Lightning Blackjack",
    //   tableCode: "EVO_XLigRou",
    //   provider: "vking",
    //   tpGameId:604
    // },
    // {
    //   src: "/Evolution_games/lightning_blackjack_thumbnail_1000x563_2023_04-400x225.jpg",
    //   name: "Lightning Blackjack",
    //   tableCode: "EVO_XLigRou",
    //   provider: "vking",
    //   tpGameId:604
    // },
    // {
    //   src: "/Evolution_games/lightning_dragon_tiger_thumbnail_1000x563_2024_03-400x225.jpg",
    //   name: "Lightning Dragon Tiger",
    //   tableCode: "EVO_XLigRou",
    //   provider: "vking",
    //   tpGameId:604
    // },
    // {
    //   src: "/Evolution_games/lightning_lotto_thumbnail_1000x563-400x225.jpg",
    //   name: "Lightning Lotto",
    //   tableCode: "EVO_XLigRou",
    //   provider: "vking",
    //   tpGameId:604
    // },
    
    // {
    //   src: "/Evolution_games/lightning_sic_bo_thumbnail_1000x563_2024_06-400x225.jpg",
    //   name: "Lightning Sic Bo",
    //   tableCode: "EVO_XLigRou",
    //   provider: "vking",
    //   tpGameId:604
    // },
    // {
    //   src: "/Evolution_games/lightning_storm_affiliate_website_banner_1000x563_2024_07-400x225.jpg",
    //   name: "Lightning Storm",
    //   tableCode: "EVO_XLigRou",
    //   provider: "vking",
    //   tpGameId:604
    // },
    // {
    //   src: "/Evolution_games/lucky_7_1000-400x225.png",
    //   name: "Lucky 7",
    //   tableCode: "EVO_XLigRou",
    //   provider: "vking",
    //   tpGameId:604
    // },
 
    // {
    //   src: "/Evolution_games/monopoly-live-thumbnail-400x225.jpg",
    //   name: "Monopoly Live",
    //   tableCode: "EVO_XLigRou",
    //   provider: "vking",
    //   tpGameId:604
    // },
    // {
    //   src: "/Evolution_games/no_commission_baccarat_1000-400x225.png",
    //   name: "No Commission Baccarat",
    //   tableCode: "EVO_XLigRou",
    //   provider: "vking",
    //   tpGameId:604
    // },
    // {
    //   src: "/Evolution_games/no_commission_baccarat_thumbnail_1000x563-400x225.jpg",
    //   name: "No Commission Baccarat Thumbnail",
    //   tableCode: "EVO_XLigRou",
    //   provider: "vking",
    //   tpGameId:604
    // },
    // {
    //   src: "/Evolution_games/one_day_teen_patti_1000-400x225.png",
    //   name: "One Day Teen Patti",
    //   tableCode: "EVO_XLigRou",
    //   provider: "vking",
    //   tpGameId:604
    // },
    // {
    //   src: "/Evolution_games/peek_baccarat_thumbnail_1000x563_2023_03-400x225.jpg",
    //   name: "Peek Baccarat",
    //   tableCode: "EVO_XLigRou",
    //   provider: "vking",
    //   tpGameId:604
    // },
    // {
    //   src: "/Evolution_games/roulette_1000-400x225.png",
    //   name: "Roulette",
    //   tableCode: "EVO_XLigRou",
    //   provider: "vking",
    //   tpGameId:604
    // },
    // {
    //   src: "/Evolution_games/roulette_500-400x225.png",
    //   name: "Roulette",
    //   tableCode: "EVO_XLigRou",
    //   provider: "vking",
    //   tpGameId:604
    // },
    // {
    //   src: "/Evolution_games/side_bet_city_1000-400x225.png",
    //   name: "Side Bet City",
    //   tableCode: "EVO_XLigRou",
    //   provider: "vking",
    //   tpGameId:604
    // },
    // {
    //   src: "/Evolution_games/texas_holdem_1000-400x225.png",
    //   name: "Texas Holdem",
    //   tableCode: "EVO_XLigRou",
    //   provider: "vking",
    //   tpGameId:604
    // },
  ];

  useEffect(() => {
    const handleResize = () => {
      // Start closed and let the visitor open it. Forcing it open
      // above 991px put a fixed panel over the page content.
      setSidebar(false);
    };

    // Add event listener for resize
    window.addEventListener("resize", handleResize);

    // Initial check to set the correct sidebar state
    handleResize();

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <app-root _nghost-jrx-c101="" ng-version="12.2.16">
      <div _ngcontent-jrx-c101="">
        <app-landing-page-new _nghost-jrx-c95="" className="ng-star-inserted">
          <div _ngcontent-jrx-c95="" className="head-container">
            <div _ngcontent-jrx-c95="" className="body-container">
              <Sidebar isSidebar={isSidebar} setSidebar={setSidebar} />
              <div
                _ngcontent-jrx-c95=""
                className={`rightbar`}
                style={{
                  width: isSidebar ? "" : "100%",
                  transition: "width 0.3s ease-in-out",
                }}
              >
                <Header isSidebar={isSidebar} setSidebar={setSidebar} />

                <Banner />

                <div className="mt-5 mb-5 newMain">
                  <p className="d-flex justify-content-between align-items-center main mx-3">
                    <span className="head">Evolution Games</span>{" "}
                    <span className="all">See All</span>
                  </p>

                  <div className="brdr text-nowrap">
                    <SliderContainer CurrentSlider={PopularGames} />
                  </div>
                </div>
                <Footer />
              </div>
            </div>
          </div>
        </app-landing-page-new>
      </div>
    </app-root>
  );
};

export default EvolutionGames;
